export function forms($) {

	//---------------------------------------------------------
	// Mark 'input', 'select' and 'textarea'  controls
	// when empty or on focus
	//---------------------------------------------------------

	$('.js--form input[type="radio"], .js--form input[type="checkbox"]').after('<span></span>');


	//---------------------------------------------------------
	// Mark 'input', 'select' and 'textarea'  controls
	// when filled or on focus
	//---------------------------------------------------------

	let $inputs = '.js--form input[type="text"], .js--form input[type="file"], .js--form input[type="date"], .js--form input[type="datetime"], .js--form input[type="email"], .js--form input[type="number"], .js--form input[type="password"], .js--form input[type="url"], .js--form input[type="tel"], .js--form select, .js--form textarea';
	let $choices = '.js--form input[type="radio"], .js--form input[type="checkbox"]';

	$($inputs)
		.filter(function () { return $(this).val() !== ""; })
		.closest('.form__field')
		.addClass('form_controlPreFilled');

	$($choices)
		.filter(function () { return $(this).is(':checked'); })
		.closest('.form__field')
		.addClass('form_controlPreFilled')
		.end()
		.filter(function () { return !$(this).is(':checked'); })
		.closest('.form__field')
		.removeClass('form_controlPreFilled');

	$('body').on('change', $inputs, function () {

		$(this).closest('.form__field').removeClass('form_controlPreFilled');

		if ($(this).val() !== "") {
			$(this)
				.closest('.form__field')
				.addClass('form_controlFilled');
		} else {
			$(this)
				.closest('.form__field')
				.removeClass('form_controlFilled');
		}
	}).on('focus', $inputs, function () {
		$(this)
			.closest('.form__field')
			.addClass('form_controlFocus');
	}).on('blur', $inputs, function () {
		$(this)
			.closest('.form__field')
			.removeClass('form_controlFocus');
	}).on('keyup', $inputs, function () {

		$(this).closest('.form__field').removeClass('form_controlPreFilled');

		if ($(this).val() !== "") {
			$(this)
				.closest('.form__field')
				.addClass('form_controlFilled');

		} else {
			$(this)
				.closest('.form__field')
				.removeClass('form_controlFilled');
		}
	});


	$('body').on('change', $choices, function () {

		$(this).closest('.form__field').removeClass('form_controlPreFilled');

		if ($(this).is(':checked')) {
			$(this)
				.closest('.form__field')
				.addClass('form_controlFilled');

		} else {
			$(this)
				.closest('.form__field')
				.removeClass('form_controlFilled');
		}
	});


}
